import React from 'react';

import { ModelContextProvider } from '@getdutchie/agent-react';

import { LD } from 'src/app/constants/launch-darkly-flags';
import { useLDFlag } from 'src/app/hooks/use-ld-flag';

export function DutchieModelContextProvider({ children }) {
  const useDutchieAgent = useLDFlag(LD.DUTCHIE_AGENT);
  return useDutchieAgent ? <ModelContextProvider children={children} /> : children;
}
